<div class="consent-container">
  <rs-web-whitelabel-image
    [whitelabelImage]="WhitelabelImage.BOTTLE_MESSAGE"
    [altTag]="WhitelabelImageAltTag.BOTTLE_MESSAGE | translate"
    [whitelabelImageType]="WhitelabelImageType.SVG"
    [onSurface]="true"
  ></rs-web-whitelabel-image>
  <h1>{{ 'consent.document_consent_title' | translate }}</h1>

  <p>
    {{ 'consent.document_consent_start' | translate }}
    <a routerLink="/legal-information" [queryParams]="{ link: 'digitalDocumentsReceival' }">
      {{ 'consent.document_consent_link' | translate }}
    </a>
  </p>

  <rs-web-form-field>
    <input [formControl]="control" id="check" class="form-check-input" type="checkbox" />
    <label for="check" class="form-check-label">
      {{ 'consent.document_consent_checkbox_l' | translate }}
    </label>
  </rs-web-form-field>

  <div class="d-flex flex-column gap-2">
    <button
      im-button
      class="primary"
      (click)="
        acceptConsent.emit({
          legalTextId: legalTexts().digitalDocumentsReceivalId,
          consentGiven: control.value,
        })
      "
      [disabled]="!control.valid || isLoading()"
    >
      {{ 'next' | translate }}
    </button>
  </div>
</div>
